const { SET_SPONSOR_PRODUCTS, RESET_SPONSOR_PRODUCTS } = require('constants/actionTypes/sponsorProducts');

const initialState = {
    products: [],
    loaded: false
};

const reducer = function (state = initialState, action = {}) {
    switch (action.type) {
        case RESET_SPONSOR_PRODUCTS:
            return initialState;

        case SET_SPONSOR_PRODUCTS:
            return {
                ...state,
                products: action.payload,
                loaded: true
            };

        default:
            return state;
    }
};

module.exports = reducer;
